export default "__VITE_ASSET__qkIus7AT__"